import { type Database } from '@databases/model/database';

import { serializeDatabaseContents } from './contents';
import { serializeDatabaseSchema } from './schema';
import { serializeDatabaseViews } from './view';
import { Warnings } from './warnings';

export function serializeDatabase(database: Database) {
  const warnings = new Warnings();
  let output = '';
  const rowIdToEntryIdMappings = new Map<string, string>();

  output += serializeDatabaseSchema(database, warnings);
  output += '\r\n\r\n';

  output += serializeDatabaseViews(database, warnings);
  output += '\r\n\r\n';

  output += serializeDatabaseContents(database, warnings, rowIdToEntryIdMappings);

  return {
    output,
    warnings,
    rowIdToEntryIdMappings,
  };
}
